import styled from 'styled-components';

const Root = styled.div ``;

export { Root };
//# sourceMappingURL=styled.js.map
